import React, { Suspense } from 'react';
import { render, hydrate } from 'react-dom';
import App from './App';
import FourDotLoader from 'components/FourDotLoader';
import credentialsService from './services/credentialsService';
import drCredentialsService from 'router/subrouters/DataRoom/services/drCredentialsService';

import 'modules/i18n';
import './index.scss';

// TODO: remove 30 days after release - one-time cleanup of legacy dr-token cookies without expiration
drCredentialsService.cleanUpTokens();

const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  hydrate(
    <React.StrictMode>
      <Suspense
        fallback={
          credentialsService.token ? (
            <FourDotLoader />
          ) : (
            <div dangerouslySetInnerHTML={{ __html: rootElement.innerHTML }} />
          )
        }
      >
        <App />
      </Suspense>
    </React.StrictMode>,
    rootElement,
  );
} else {
  render(
    <React.StrictMode>
      <Suspense fallback={<FourDotLoader />}>
        <App />
      </Suspense>
    </React.StrictMode>,
    rootElement,
  );
}
